import {
	connect
} from 'react-redux'
import MaintenanceOrderDetailEditComponent from '../components/MaintenanceOrderDetailEditComponent.jsx';
import {
	forwardToSelectDetailCategory,
	forwardToSelectDetailCheckSet,
	forwardToChangeMaintenanceOrderDetailValue,
	forwardToCreateNewMOrdeDetail,
	forwardToFindMOrderDetails,
	forwardToDeleteMaintenanceOrderDetail,
} from '../actions';

const mapStateToProps = (state) => ({
	orderDetail: state.getIn(['maintenanceOrderReducer', 'orderDetail']),
	categories: state.getIn(['checkCardReducer', 'view']).get('categories'),
	orderDetailValidation: state.getIn(['maintenanceOrderReducer', 'orderDetailValidation']),
	alertStyle: state.getIn(['maintenanceOrderReducer', 'alertStyle']),
	alertMessage: state.getIn(['maintenanceOrderReducer', 'alertMessage']),
	forInsert: state.getIn(['maintenanceOrderReducer', 'forInsert']),
})

const mapDispatchToProps = (dispatch) => ({
	selectDetailCategory: (index, category) => {
		dispatch(forwardToSelectDetailCategory(index, category));
	},
	selectDetailCheckSet: (index, category) => {
		dispatch(forwardToSelectDetailCheckSet(index, category));
	},

	setValue: (id, value) => {
		dispatch(forwardToChangeMaintenanceOrderDetailValue({
			id: id,
			value: value
		}))
	},

	newOrderDetail:(orderId,category,checkSet,sPrice, sQuantity) =>{
		dispatch(forwardToCreateNewMOrdeDetail({
			orderId: orderId,
			category: category,
			checkSet: checkSet,
			sPrice:sPrice,
			sQuantity: sQuantity
		}))
	},

	findMaintenanceOrderDetails: (orderid) =>{
		dispatch(forwardToFindMOrderDetails(orderid))
	},

	deleteMaintenanceOrderDetail: (detailId, orderId) => {
		dispatch(forwardToDeleteMaintenanceOrderDetail(detailId, orderId))
	},
})



const MaintenanceOrderDetailEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)(MaintenanceOrderDetailEditComponent)

export default MaintenanceOrderDetailEditContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceOrderDetailEditContainer.jsx